/**
 * Decodes a JWT token to extract its payload
 * @param {string} token - JWT string
 * @returns {object|null} Decoded payload or null if invalid
 */
export function decodeJWT(token) {
  if (!token || typeof token !== "string") return null;

  const parts = token.split(".");
  if (parts.length !== 3) {
    console.error("Invalid JWT format");
    return null;
  }

  try {
    const payload = JSON.parse(atob(parts[1]));
    console.log("Decoded JWT Payload:", payload);
    return payload;
  } catch (err) {
    console.error("Error decoding JWT payload:", err);
    return null;
  }
}